export function createMultiOfferTip(
	offer: {
		eventId: string;
		value: number;
	} & (
		| {
				multiOffers?: {
					bettingOfferId: string;
					value?: number;
				}[];
		  }
		| {
				id: string;
		  }
	)
) {
	// Check if the offer has `multiOffers`
	if (
		"multiOffers" in offer &&
		offer.multiOffers &&
		offer.multiOffers.length > 0
	) {
		return {
			eventId: offer.eventId,
			value: offer.value,
			isBank: false,
			multiOffers: offer.multiOffers.map((mo) => ({
				multiOfferId: mo.bettingOfferId,
				value: mo.value,
			})),
		};
	}

	// If the offer has `id` instead of `multiOffers`
	if ("id" in offer) {
		return {
			eventId: offer.eventId,
			value: offer.value,
			isBank: false,
			multiOffers: [
				{
					multiOfferId: offer.id,
					value: offer.value,
				},
			],
		};
	}

	// Handle case where neither multiOffers nor id exists (should not happen)
	throw new Error("Invalid offer structure");
}
